import apiService from './api';
import { RespostaPaginada } from '../types';

/**
 * Monta a query string ignorando os parametros nao informados, para que uma
 * chamada sem paginacao continue batendo na rota sem sufixo nenhum.
 */
const montarQuery = (filtros: Record<string, string | number | undefined>): string => {
  const params = new URLSearchParams();
  Object.entries(filtros).forEach(([chave, valor]) => {
    if (valor !== undefined && valor !== '') params.append(chave, String(valor));
  });
  const query = params.toString();
  return query ? `?${query}` : '';
};

export const aprovacaoService = {
  // `page`/`perPage` sao opcionais: sem eles o servidor aplica o proprio padrao,
  // entao quem ainda nao migrou para a paginacao segue funcionando.
  getPendentes: async (page?: number, perPage?: number): Promise<RespostaPaginada<any>> => {
    return apiService.get<RespostaPaginada<any>>(
      `/v1/aprovacoes/pendentes${montarQuery({ page, per_page: perPage })}`
    );
  },

  getHistorico: async (
    statusAprovacao?: string,
    page?: number,
    perPage?: number
  ): Promise<RespostaPaginada<any>> => {
    return apiService.get<RespostaPaginada<any>>(
      `/v1/aprovacoes/historico${montarQuery({ status_aprovacao: statusAprovacao, page, per_page: perPage })}`
    );
  },

  contarPendentes: async () => {
    return apiService.get<{ success: boolean; data: { pendentes: number } }>('/v1/aprovacoes/contar-pendentes');
  },

  aprovar: async (id: number) => {
    return apiService.post<any>(`/v1/aprovacoes/${id}/aprovar`);
  },

  rejeitar: async (id: number, motivo: string) => {
    return apiService.post<any>(`/v1/aprovacoes/${id}/rejeitar`, { motivo_rejeicao: motivo });
  },
};

export const cadastroPublicoService = {
  validarCodigo: async (codigo: string) => {
    return apiService.get<any>(`/cadastro-motorista/validar/${codigo}`);
  },

  cadastrar: async (data: any) => {
    return apiService.post<any>('/cadastro-motorista', data);
  },
};

